import type { Entity } from '@core/types';
import { photoApiV1 } from '@deepup/apis';
import { iphotoContentClassificationApiV1 as iphotoContentClassificationApi } from '@deepup/internal-apis';
import { OrderNumber } from '@projects/types/orderNumbers';

export const ascQualitySortedGeoPositionSolutions = ['CORELOCATION', 'FLOAT', 'FIXED'] as const;
export type GeoPositionSolution = (typeof ascQualitySortedGeoPositionSolutions)[number];

export interface Photo extends Entity {
  address: string | null;
  comment: string | null;
  deviceId: string;
  geoPositionSolution: GeoPositionSolution;
  lat: number;
  long: number;
  projectId: string | null;
  recordedAt: string;
  url: string;
  category?: { id: string | null; name: string } | null;
  classification?: iphotoContentClassificationApi.PhotoContentClassification;
  orderNumbers?: OrderNumber[];
}

export type PhotoWithClassification = photoApiV1.Photo & {
  classification?: iphotoContentClassificationApi.PhotoContentClassification;
};
